import * as Icons from "lucide-react";

export default function DynamicIcon({ name, className = "h-6 w-6", ...props }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} {...props} />;
}
